import {connectRouter} from 'connected-react-router'
import {combineReducers} from "redux"
import {reducer as formReducer} from 'redux-form'
import {CHANGE_HEADER_CONTENT, RESET_ALERTS} from "../actions"
import paginate from "./paginate"
import entity from "./entity"
import {HIDE_MODAL, SHOW_MODAL} from "../actions/modal"
import session from "./session"
import * as EnumsActions from '../actions/enums'
import * as PartiesActions from '../actions/parties'
import * as InvoicesActions from '../actions/invoices'
import * as TransactionsActions from '../actions/transactions'
import * as UsersActions from '../actions/users'

const enums = (state = {}, action) => {
	const {type, key} = action;

	let newState = {...state};
	switch (type) {
		case EnumsActions.ENUM_REQUEST:
			return {
				...state,
				[key]: {
					items: {},
					isFetchingInfo: true
				}
			};
		case EnumsActions.ENUM_SUCCESS:
			return {
				...state,
				[key]: {
					items: action.response.data,
					isFetchingInfo: false
				}
			};
		case EnumsActions.ENUM_FAILURE:
			return {
				...state,
				[key]: {
					isFetchingInfo: false
				}
			};
		case EnumsActions.ENUMS_REQUEST:
			for (let i = 0; i < key.length; i++) {
				newState[key[i]] = {
					items: {},
					isFetchingInfo: true
				};
			}
			return newState;
		case EnumsActions.ENUMS_SUCCESS:
			for (let i = 0; i < key.length; i++) {
				newState[key[i]] = {
					items: action.response.data[key[i]],
					isFetchingInfo: false
				};
			}
			return newState;
		case EnumsActions.ENUMS_FAILURE:
			for (let i = 0; i < key.length; i++) {
				newState[key[i]] = {
					isFetchingInfo: false
				};
			}
			return newState;
		default:
			return state
	}
};

const defaultAlerts = {type: null, messages: []};

const alerts = (state = defaultAlerts, action) => {
	const {type, error, success, silent = false} = action;

	if (type === RESET_ALERTS) {
		return {
			...state,
			type: null,
			messages: []
		}

	} else if ((error || success) && !silent && type.indexOf("@@redux-form") !== 0) {
		const messages = Object.assign(state.messages);
		if (messages.length > 5) {
			messages.shift()
		}
		messages.push(error || success);
		return {
			type: error ? 'danger' : 'success',
			messages
		}
	}

	return state
};

const headerContent = (state = {content: null}, action) => {
	const {type, content} = action;

	if (type === CHANGE_HEADER_CONTENT) {
		return Object.assign({}, state, {
			content: content
		})
	} else {
		return state
	}
};

const pagination = combineReducers({
	parties: paginate({
		types: [
			PartiesActions.PARTIES_REQUEST,
			PartiesActions.PARTIES_SUCCESS,
			PartiesActions.PARTIES_FAILURE,
			PartiesActions.PARTIES_COUNT_REQUEST,
			PartiesActions.PARTIES_COUNT_SUCCESS,
			PartiesActions.PARTIES_COUNT_FAILURE
		]
	}),
	invoices: paginate({
		types: [
			InvoicesActions.INVOICES_REQUEST,
			InvoicesActions.INVOICES_SUCCESS,
			InvoicesActions.INVOICES_FAILURE,
			InvoicesActions.INVOICES_COUNT_REQUEST,
			InvoicesActions.INVOICES_COUNT_SUCCESS,
			InvoicesActions.INVOICES_COUNT_FAILURE
		]
	}),
	transactions: paginate({
		types: [
			TransactionsActions.TRANSACTIONS_REQUEST,
			TransactionsActions.TRANSACTIONS_SUCCESS,
			TransactionsActions.TRANSACTIONS_FAILURE,
			TransactionsActions.TRANSACTIONS_COUNT_REQUEST,
			TransactionsActions.TRANSACTIONS_COUNT_SUCCESS,
			TransactionsActions.TRANSACTIONS_COUNT_FAILURE
		]
	}),
	users: paginate({
		types: [
			UsersActions.USERS_REQUEST,
			UsersActions.USERS_SUCCESS,
			UsersActions.USERS_FAILURE,
			UsersActions.USERS_COUNT_REQUEST,
			UsersActions.USERS_COUNT_SUCCESS,
			UsersActions.USERS_COUNT_FAILURE
		]
	})
});

const entities = combineReducers({
	parties: entity({
		types: [
			PartiesActions.PARTY_REQUEST,
			PartiesActions.PARTY_SUCCESS,
			PartiesActions.PARTY_FAILURE,
			PartiesActions.PARTY_SAVE_REQUEST,
			PartiesActions.PARTY_SAVE_SUCCESS,
			PartiesActions.PARTY_SAVE_FAILURE
		],
		key: 'partyId'
	}),
	invoices: entity({
		types: [
			InvoicesActions.INVOICE_REQUEST,
			InvoicesActions.INVOICE_SUCCESS,
			InvoicesActions.INVOICE_FAILURE,
			InvoicesActions.INVOICE_SAVE_REQUEST,
			InvoicesActions.INVOICE_SAVE_SUCCESS,
			InvoicesActions.INVOICE_SAVE_FAILURE,
			InvoicesActions.INVOICE_DELETE_REQUEST,
			InvoicesActions.INVOICE_DELETE_SUCCESS,
			InvoicesActions.INVOICE_DELETE_FAILURE,
		],
		key: 'invoiceId'
	}),
	transactions: entity({
		types: [
			TransactionsActions.TRANSACTION_REQUEST,
			TransactionsActions.TRANSACTION_SUCCESS,
			TransactionsActions.TRANSACTION_FAILURE,
			TransactionsActions.TRANSACTION_SAVE_REQUEST,
			TransactionsActions.TRANSACTION_SAVE_SUCCESS,
			TransactionsActions.TRANSACTION_SAVE_FAILURE,
			TransactionsActions.TRANSACTION_DELETE_REQUEST,
			TransactionsActions.TRANSACTION_DELETE_SUCCESS,
			TransactionsActions.TRANSACTION_DELETE_FAILURE,
		],
		key: 'trnId'
	}),
	users: entity({
		types: [
			UsersActions.USER_REQUEST,
			UsersActions.USER_SUCCESS,
			UsersActions.USER_FAILURE,
			UsersActions.USER_SAVE_REQUEST,
			UsersActions.USER_SAVE_SUCCESS,
			UsersActions.USER_SAVE_FAILURE,
			UsersActions.USER_DELETE_REQUEST,
			UsersActions.USER_DELETE_SUCCESS,
			UsersActions.USER_DELETE_FAILURE,
		],
		key: 'userId'
	})
});

const defaultModalState = {isShowing: false, title: '', message: '', button: null, onConfirm: null};

function modal(state = defaultModalState, action) {
	switch (action.type) {
		case SHOW_MODAL:
			return Object.assign({}, state, {
				isShowing: true,
				message: action.message,
				title: action.title,
				button: action.button,
				onConfirm: action.onConfirm
			});
		case HIDE_MODAL:
			return Object.assign({}, state, defaultModalState);
		default:
			return state
	}
}

const rootReducer = (history) => combineReducers({
	headerContent,
	session,
	enums,
	pagination,
	entities,
	alerts,
	router: connectRouter(history),
	modal,
	form: formReducer,
});

export default rootReducer
